import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { PaperPlaneTilt, ShieldCheck, Eye, EyeSlash } from "@phosphor-icons/react";
const BG_URL =
  "https://static.prod-images.emergentagent.com/jobs/fa232cd9-0eae-4d04-82d8-ba6f3508d2ae/images/4f187685c3d756b9758c17beab35b06c291cb5c987d30da4ba466ee985b1bbc2.png";

export default function LoginPage() {
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [showPass, setShowPass] = useState(false);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();
  const auth = useAuth();

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await auth.login(login.trim(), password);
      nav("/");
    } catch (e2) {
      setErr(e2.response?.data?.detail || "Ошибка авторизации");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex" data-testid="login-page">
      {/* Left – background */}
      <div
        className="hidden lg:flex flex-1 relative overflow-hidden"
        style={{
          backgroundImage: `linear-gradient(135deg, rgba(9,9,11,0.4), rgba(9,9,11,0.9)), url(${BG_URL})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="grain absolute inset-0" />
        <div className="relative z-10 p-12 flex flex-col justify-between w-full">
          <div>
            <img
              src="/stratoplan-logo.png"
              alt="Stratoplan Management School"
              className="h-12 w-auto select-none"
            />
            <div className="text-[10px] uppercase tracking-[0.22em] text-zinc-500 mt-3">
              Bot Admin · CRM
            </div>
          </div>
          <div className="space-y-3 max-w-md">
            <h1 className="text-4xl font-bold tracking-tight">
              Управление ботом
            </h1>
            <p className="text-zinc-400 leading-relaxed">
              Сегментация, рассылки, каталог программ, аналитика и CRM-карточки
              подписчиков — всё в одном месте.
            </p>
          </div>
        </div>
      </div>

      {/* Right – form */}
      <div className="flex-1 flex items-center justify-center px-6 lg:px-12 bg-zinc-950">
        <form
          onSubmit={onSubmit}
          className="w-full max-w-sm space-y-6 fade-up"
          data-testid="login-form"
        >
          <div className="lg:hidden flex items-center gap-2 mb-8">
            <img
              src="/stratoplan-logo.png"
              alt="Stratoplan"
              className="h-10 w-auto"
            />
          </div>

          <div className="space-y-2">
            <div className="text-xs uppercase tracking-[0.2em] text-blue-500">Вход</div>
            <h2 className="text-2xl font-semibold tracking-tight">Добро пожаловать</h2>
            <p className="text-sm text-zinc-400">
              Войдите, чтобы продолжить работу с CRM.
            </p>
          </div>

          <div className="space-y-3">
            <div>
              <label className="text-xs text-zinc-400 mb-1.5 block">Логин</label>
              <input
                data-testid="login-input"
                value={login}
                onChange={(e) => setLogin(e.target.value)}
                autoFocus
                className="w-full bg-zinc-900 border border-zinc-800 rounded-md px-3 py-2.5 text-sm
                           focus:outline-none focus:border-blue-500/60 focus:ring-2 focus:ring-blue-500/10
                           transition-colors"
                placeholder="admin"
                autoComplete="username"
              />
            </div>
            <div>
              <label className="text-xs text-zinc-400 mb-1.5 block">Пароль</label>
              <div className="relative">
                <input
                  data-testid="password-input"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  type={showPass ? "text" : "password"}
                  className="w-full bg-zinc-900 border border-zinc-800 rounded-md px-3 py-2.5 text-sm pr-10
                             focus:outline-none focus:border-blue-500/60 focus:ring-2 focus:ring-blue-500/10
                             transition-colors"
                  placeholder="••••••••"
                  autoComplete="current-password"
                />
                <button
                  type="button"
                  onClick={() => setShowPass((p) => !p)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-zinc-500 hover:text-zinc-300"
                  data-testid="toggle-password-btn"
                >
                  {showPass ? <EyeSlash size={16} /> : <Eye size={16} />}
                </button>
              </div>
            </div>
          </div>

          {err && (
            <div
              data-testid="login-error"
              className="text-sm text-red-400 bg-red-500/10 border border-red-500/20 rounded-md px-3 py-2"
            >
              {err}
            </div>
          )}

          <button
            data-testid="login-submit-btn"
            disabled={loading}
            type="submit"
            className="w-full bg-blue-500 hover:bg-blue-600 disabled:opacity-50 disabled:cursor-not-allowed
                       text-white font-semibold rounded-md py-2.5 text-sm transition-colors
                       shadow-[0_8px_24px_-6px_rgba(59,130,246,0.45)]"
          >
            {loading ? "Входим…" : "Войти"}
          </button>

          <div className="text-xs text-zinc-600 text-center font-mono">
            v0.1 · Stratoplan CRM
          </div>
        </form>
      </div>
    </div>
  );
}
